/**
 * 系统用户接口列表
 */
import axios from '@/request/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const goods = {
  // 获取预售活动列表
  getPresellGoodsList(params) {
    return axios.post('/goods/mobileGoods/getPresellGoodsList', qs.stringify(params));
  },
  // 获取所有商品分类列表信息
  getAllGoodsClassList(params) {
    return axios.post('/goods/mobileGoodsType/getAllGoodsClassList', qs.stringify(params));
  },
  //首页获取所有商品一级分类列表信息
  getAllGoodsTopClassList(params) {
    return axios.post('/goods/mobileGoodsType/getGoodsTopClassList', qs.stringify(params));
  },
  // 对接 首页一级品牌分类
  getGoodsTopBrandList(params) {
    return axios.post('/goods/mobileGoodsType/getGoodsTopBrandList', qs.stringify(params));
  },
  // 对接 首页所有品牌分类
  getAllGoodsBrandList(params) {
    return axios.post('/goods/mobileGoodsType/getAllGoodsBrandList', qs.stringify(params));
  },
  // 对接 根据品牌id获取商品列表
  getGoodsListByBrandId(params) {
    return axios.post('/goods/mobileGoods/getGoodsListByBrandId', qs.stringify(params));
  },
  //根据商品分类id获取商品列表信息
  getGoodsListByTypeId(params, config = {}) {
    return axios.post('/goods/mobileGoods/getGoodsListByTypeId', qs.stringify(params), config);
  },
  //获取常用清单列表（商城端）
  getCommonlyUsedList(params) {
    return axios.post('/goods/mobileGoods/getCommonlyUsedList', qs.stringify(params));
  },
  //获取首页商品类型模块以及模块商品
  getModularAndGoods(params) {
    return axios.post('/goods/mobileGoods/showIndexModularGoods', qs.stringify(params));
  },
  //根据商品类型id获取商品列表信息
  getGoodsListByPromoId(params) {
    return axios.post('/goods/mobileGoods/getGoodsListByPromoId', qs.stringify(params));
  },
  //获取商品详情信息
  getGoodsDetailInfo(params) {
    return axios.post('/goods/mobileGoods/getGoodsDetailByGoodsId', qs.stringify(params));
  },
  //用户添加商品足迹商品
  addUserHistoryGoods(params) {
    return axios.post('/goods/mobileGoods/addUserHistoryGoods', qs.stringify(params));
  },
  //获取用户足迹商品列表信息
  showUserHistoryGoods(params) {
    return axios.post('/goods/mobileGoods/showUserHistoryGoods', qs.stringify(params));
  },
  //收藏或取消收藏商品
  collectOrCancelCollectGoods(params) {
    return axios.post('/goods/mobileGoods/collectOrCancelCollectGoods', qs.stringify(params));
  },
  //获取用户收藏商品列表信息
  showUserCollectGoodsList(params) {
    return axios.post('/goods/mobileGoods/showUserCollectGoodsList', qs.stringify(params));
  },
  //删除用户收藏或足迹商品列表信息
  deleteUserRelationGoods(params) {
    return axios.post('/goods/mobileGoods/deleteUserRelationGoods', qs.stringify(params));
  },
  //获取用户足迹商品列表信息
  showUserHistoryGoodsList(params) {
    return axios.post('/goods/mobileGoods/showUserHistoryGoodsList', qs.stringify(params));
  },
  //获取爆款推荐商品列表信息
  getFaddishGoodsList(params) {
    return axios.post('/goods/mobileGoods/getFaddishGoodsList', qs.stringify(params));
  },
  //获取秒杀活动列表信息
  getSeckillList(params) {
    return axios.post('/goods/mobileGoods/getSeckillList', qs.stringify(params));
  },
  //获取描述活动信息
  getSeckillGoodsList(params) {
    return axios.post('/goods/shopActivity/getShopActivityList', qs.stringify(params));
  },
  //获取特价页面活动列表信息
  getSpecialList(params) {
    return axios.post('/goods/mobileGoods/getSpecialList', qs.stringify(params));
  },
  //获取特价活动页面活动以及商品信息
  getSpecialGoodsList(params) {
    return axios.post('/goods/mobileGoods/getSpecialGoodsList', qs.stringify(params));
  },
  //获取组合套餐活动页面活动以及商品信息
  getPackageGoodsList(params) {
    return axios.post('/goods/mobileGoods/getPackageGoodsList', qs.stringify(params));
  },
  //获取拼团活动页面活动信息
  getSpellGroupList(params) {
    return axios.post('/goods/mobileGoods/getSpellGroupList', qs.stringify(params));
  },
  //获取拼团活动页面活动以及商品信息
  getSpellGroupGoodsList(params) {
    return axios.post('/goods/mobileGoods/getSpellGroupGoodsList', qs.stringify(params));
  },
  //搜索商品列表信息
  searchGoodsList(params) {
    return axios.post('/goods/mobileGoods/searchGoodsList', qs.stringify(params));
  },
  // //获取商品价格 废弃接口
  // getGoodsPriceByItemNo(params) {
  //     return axios.post('/fp/mobileGoods/getGoodsPriceByItemNo', qs.stringify(params));
  // },
  //获取商品价格
  getPresellGoodsList(params) {
    return axios.post('/goods/mobileGoods/getPresellGoodsList', qs.stringify(params));
  },
  //计算最终商品促销优惠
  countGoodsPromotionFinalRule(params) {
    return axios.post('/goods/mobileGoodsPromotion/countGoodsPromotionFinalRule', qs.stringify(params));
  },
  //根据选择单位查询对应组合套餐
  getPackageActivityList(params) {
    return axios.post('/goods/mobileGoods/getPackageActivityList', qs.stringify(params));
  },
  //获取商品促销活动页面活动信息
  getGoodsPromotionList(params) {
    return axios.post('/goods/mobileGoods/getGoodsPromotionList', qs.stringify(params));
  },
  //获取商品促销页面活动以及商品信息
  getGoodsPromotionGoodsList(params) {
    return axios.post('/goods/mobileGoods/getGoodsPromotionGoodsList ', qs.stringify(params));
  },
  //通过商品id列表获取商品信息
  getMobileGoodsListByGoodsId(params) {
    return axios.post('/goods/mobileGoods/getMobileGoodsListByGoodsId ', qs.stringify(params));
  },
  // 定制版根据appId获取企业信息
  getShareCompanyInfo(params) {
    return axios.post('/order/sysConfig/getShareCompanyInfo', qs.stringify(params));
  },
  //商品添加备注
  addOrUpdateUserGoodsRemark(params) {
    return axios.post('/goods/mobileGoods/addOrUpdateUserGoodsRemark', qs.stringify(params));
  },
  //商品备注
  getPointUserGoodsRemark(params) {
    return axios.post('/goods/mobileGoods/getPointUserGoodsRemark', qs.stringify(params));
  },
  //加购物车限制商品种类
  getBucketTypeSum(params) {
    return axios.post('/goods/mobileBucket/getBucketTypeSum', qs.stringify(params));
  },
  //加购物车限制商品种类
  getShopBannerList(params) {
    return axios.post('/goods/home_page/getShopBannerList', qs.stringify(params));
  },
  //门店列表
  getStoreList(params) {
    return axios.post('/goods/home_page/getStoreList', qs.stringify(params));
  },
  //对接版订货端搜索页面选择模块接口
  getSelectGoodsInfoDock(params) {
    return axios.post('/goods/mobileGoods/getSelectGoodsInfoDock', qs.stringify(params));
  },
  //搜索关键字列表提示接口信息接口
  querySearchSimilar(params) {
    return axios.post('/goods/querySearch/querySearchSimilar', qs.stringify(params));
  },
}
export default goods;



// WEBPACK FOOTER //
// ./src/request/api/goods/goods.js